module.exports = __webpack_public_path__ + "static/media/photo32.20152aa7.jpg";